<template>
    <div>
        <!-- HEADER FOR ALL CLUSTERS -->
        <h1>General Positions</h1>
        <!-- <h4>The Marketing Cluster acts as an intermediary between MISA and external entities such as corporate partners, organizational partners, and alumni. The cluster establishes and maintains relationships with MISA’s partners and alumni to assist MISA and its events through the provisions and support of corporate partners, organizations within and outside Ateneo, and the alumni.</h4> -->

        <!-- POSITIONS -->
        <!-- <h3>Positions:</h3> -->


        <!-- POSITION -->
        <h2><b>Marketing Officer</b></h2>

        <!-- <h4>The Associate Vice President for Corporate Relations aids the Marketing Vice President in creating, negotiating, and maintaining deals and agreements with MISA’s Corporate Partners who will be providing the organization additional resources and financial assistance in MISA events and projects. </h4> -->

        <h4>Responsibilities:</h4>
        <ul>
            <li>Drafting contracts for both corporate and organizational partners</li>
            <li>Assists the AVPs in accomplishing MISA’s deliverables in the partnership</li>
            <li>Inviting and coordinating with the alumni for MISA events</li>
            <li>Aids the AVPs and Senior Relations Managers of the currently assigned sub-cluster in their respective responsibilities</li>
            <li>Oversees building and maintaining relationships with various partners, either it be Corporate, Organizational, or Alumni related, on MISA’s behalf</li>
        </ul>

        <!-- POSITION -->
        <!-- <h2><b>Marketing Officer</b></h2> -->

        <!-- <h4>The Associate Vice President for Corporate Relations aids the Marketing Vice President in creating, negotiating, and maintaining deals and agreements with MISA’s Corporate Partners who will be providing the organization additional resources and financial assistance in MISA events and projects. </h4> -->

        <!-- <h4>Responsibilities:</h4>
        <ul>
            <li>All Marketing Officers rotate among the three sub-clusters for a period of two to four months in each sub-cluster depending on MISA’s calendar of events.</li>
            <li>Drafting contracts for both corporate and organizational partners</li>
            <li>Assists the AVPs in accomplishing MISA’s deliverables in the partnership</li>
            <li>Inviting and coordinating with the alumni for MISA events</li>
            <li>Aids the AVPs and Senior Relations Managers of the currently assigned sub-cluster in their respective responsibilities</li>
            <li>Oversees building and maintaining relationships with various partners, either it be Corporate, Organizational, or Alumni related, on MISA’s behalf</li>
        </ul> -->

        <!-- POSITION -->
        <!-- <h2><b>Associate Vice President for Organizational Relations</b></h2>

        <h4>The Associate Vice President for Organizational Relations helps the Vice President in maintaining and building relationships with various organizations, within and outside the Ateneo Campus, on MISA's behalf. </h4>

        <h4>Responsibilities:</h4>
        <ul>
            <li>Familiarizing and interacting with other organizations both inside and outside of Ateneo.</li>
            <li> Assists the VP in making sure all the deliverables in the organizational partnership contracts are followed</li>
            <li>Training the Senior Organizational Relations Manager/s and Marketing Officers of the cluster to let them learn the ropes of the Organizational Relations sub-cluster</li>
        </ul> -->

        <!-- POSITION -->
        <!-- <h2><b>Associate Vice President for Alumni Relations</b></h2>

        <h4>The Associate Vice President for Alumni Relations helps the Vice President in contacting and maintaining relations with the alumni of the organization. </h4>

        <h4>Responsibilities:</h4>
        <ul>
            <li>Heads MISA Networking Night event/s throughout the year as Project Director</li>
            <li>Invites the alumni to various events of MISA</li>
            <li>Attains possible partnerships with companies that the alumni may be affiliated with</li>
            <li>Assists the Vice President in introducing the cluster officers to fellow alumni to be able to build and maintain new relations </li>
            <li>Trains the Senior Alumni Relations Manager/s and Marketing Officers of the cluster to let them learn the ropes of the Alumni Relations sub-cluster</li>
        </ul> -->

        <!-- FOOTNOTES? -->
        <br>
        <p></p>
    </div>
</template>

<script>
export default {
    name: 'PrimerMarketing'
}
</script>

<style scoped>
h1{
    font-size: 4.5vw;
}
</style>


